import { paletteBase } from '@abg/kit-base';

export const buttonStyles = {
  width: '100%',
  height: '40px',
  display: 'flex',
  gap: '8px',
  color: paletteBase.black,
  backgroundColor: paletteBase.white100,
  border: `1px solid ${paletteBase.neutralGrey700}`,

  ':hover': {
    backgroundColor: paletteBase.white100,
  },
  '.MuiTypography-root': {
    fontWeight: 500,
    lineHeight: '14px',
  },
};

export const iconStyles = {
  fontSize: '16px',
};
